import { Button } from '@/view/components/ui/button'
import { DialogClose, DialogContent } from '@/view/components/ui/dialog'
import { TickCircle } from 'iconsax-react'
import useProposalSuccessModal from './useProposalSuccessModal'
import { ProposalData } from '..'
import { format } from 'date-fns'

interface ProposalSuccessModalProps {
  proposalData: ProposalData
}

export default function ProposalSuccessModal({
  proposalData,
}: ProposalSuccessModalProps) {
  const { copyWhatsAppLink } = useProposalSuccessModal({
    proposalData,
  })

  return (
    <DialogContent
      closeOnClickOutside={false}
      className="flex flex-col gap-8 overflow-y-auto p-6 sm:max-w-2xl"
    >
      <div className="mt-4 flex flex-col items-start gap-1.5 px-6">
        <TickCircle variant="Bold" size={40} className="text-success" />
        <strong className="font-semibold">Proposta realizada</strong>
        <p className="text-sm font-medium text-black04">
          A proposta está em andamento. Compartilhe o link com o cliente para
          continuar. Você será notificado quando ele finalizar.
        </p>
        {proposalData.linkExpirationDate && (
          <p className="text-sm font-medium text-success">
            Expira em: {format(new Date(proposalData.linkExpirationDate), 'dd/MM/yyyy')}
          </p>
        )}
      </div>

      <div className="flex justify-end gap-2 px-6">
        <Button
          variant="outline"
          className="w-[180px] rounded-full text-primary"
          onClick={copyWhatsAppLink}
        >
          Copiar link
        </Button>
        <DialogClose asChild>
          <Button className="w-[180px] rounded-full font-semibold text-white">
            Voltar para o início
          </Button>
        </DialogClose>
      </div>
    </DialogContent>
  )
}
